module.exports = __webpack_public_path__ + "static/timeline2018-4b4f2f5f051094c6e41d809083febcf2.jpeg";